import React from "react"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"
import ToggleButton from "@mui/material/ToggleButton"
import { useSearchParams } from "react-router-dom"

const StatusFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newStatus: string,
  ) => {
    if (newStatus !== null) {
      const currentParams = Object.fromEntries(searchParams.entries())
      setSearchParams({ ...currentParams, status: newStatus })
    }
  }

  const period = searchParams.get("status") || "active"

  const ToggleButtons = [
    { title: "Завершённые", value: "completed" },
    { title: "Активные", value: "active" },
  ]

  return (
    <ToggleButtonGroup
      color="primary"
      value={period}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      size="small"
      sx={{
        height: "40px",
        ".MuiToggleButton-root": {
          textTransform: "none",
          fontSize: "14px",
          fontWeight: "bold",
          border: "none",
          bgcolor: "rgba(221, 234, 220, 1)",
          color: "#1B9C18",
          px: "20px",
        },
      }}
    >
      {ToggleButtons.map((button) => (
        <ToggleButton
          sx={{
            "&.Mui-selected": {
              bgcolor: "#1B9C18 !important",
              color: "white !important",
            },
          }}
          value={button.value}
          key={button.value}
        >
          {button.title}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default StatusFilter
